export default __webpack_public_path__ + "static/media/image-55.fe73f136.png";